export function svgMarkupDataUrl(markup: string): string {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(markup)}`;
}

export function withoutSvgExportTitles(markup: string): string {
  return markup.replace(
    /<text\b(?=[^>]*\bdata-export-title="true")[^>]*>[\s\S]*?<\/text>/gi,
    '',
  );
}

export function svgElementMarkupForExport(element: SVGSVGElement): string {
  return withoutSvgExportTitles(new XMLSerializer().serializeToString(element));
}
